import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const formStyles = css({
  marginBottom: theme.spacing(2),
  flexGrow: 1,
});
